export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCEEDED = 'FETCH_PRODUCTS_SUCCEEDED';
export const FETCH_PRODUCTS_FAILED = 'FETCH_PRODUCTS_FAILED';

export type ProductsErrorType = {};

export type ProductsFilterStore = {
    filters: {
        page: number,
        limit: number,
        primarySchool: Array<string>,
        bookSeries: Array<string>,
        schoolSubjects: Array<string>,
        highSchool: Array<string>,
        gymnasium: Array<string>,
    },
};

export type ProductsFilters = Partial<{
    page: number,
    limit: number,
    primarySchool: Array<string> | string,
    bookSeries: Array<string> | string,
    schoolSubjects: Array<string> | string,
    highSchool: Array<string> | string,
    gymnasium: Array<string> | string,
}>;